import classes from './Container.module.scss';

export const Container: React.FC = (props) => <div className={classes.root}>{props.children}</div>;
